import { MIN_DATE } from '../../constants/constants';
import { checkDate, checkDateInterval, checkNotEmpty } from '../../helpers/validators';
export const validateBirthDay = ({ value, required }) => {
    const minYear = MIN_DATE.split('/').slice(-1);
    const maxDate = new Date().toISOString();
    if (required) {
        return (checkNotEmpty({ value }) ||
            checkDate({ value }) ||
            checkDateInterval({
                value,
                maxDate,
                message: `Дата рождения должна быть в прошлом, но не раньше ${minYear} года`,
            }));
    }
    return value
        ? checkDate({ value }) ||
            checkDateInterval({
                value,
                maxDate,
                message: `Дата рождения должна быть в прошлом, но не раньше ${minYear} года`,
            })
        : null;
};
